import { defineStore } from 'pinia';

interface UseMegaMenuMobileStoreInterface {
  open: boolean;
  menuLayersVisible: boolean;
  desktopMenuOpen: boolean;
}

export const useMegaMenuMobileStore = defineStore('megaMenuMobile', {
  state: (): UseMegaMenuMobileStoreInterface => ({
    open: false,
    menuLayersVisible: false,
    desktopMenuOpen: false
  }),
  getters: {
    isOpen: (state): boolean => state.open,
    isMenuLayersVisible: (state): boolean => state.menuLayersVisible,
    isDesktopMenuOpen: (state): boolean => state.desktopMenuOpen
  },
  actions: {
    hide(): void {
      this.open = false;
    },
    show(): void {
      this.open = true;
    },
    toggle(): void {
      this.open = !this.open;
    },
    hideMenuLayers(): void {
      this.menuLayersVisible = false;
    },
    showMenuLayers(): void {
      this.menuLayersVisible = true;
    },
    setMenuLayersVisible(visible: boolean): void {
      this.menuLayersVisible = visible;
    },
    setDesktopMenuOpen(open: boolean): void {
      this.desktopMenuOpen = open;
    }
  }
});
